import * as Yup from 'yup'
import { PASSWORD_MIN_LENGTH } from '@/consts/form'
import { SCORE_STRONG } from '@/packages/password-strength-meter'

export const validationSchema = Yup.object({
  current_password: Yup.string().when(['$withCurrent'], (...args) => {
    const [params, schema] = args
    const [withCurrent] = params
    return withCurrent ? schema.required() : schema
  }),

  new_password: Yup.string()
    .required()
    .min(PASSWORD_MIN_LENGTH)
    .test('score', { key: 'field.error.password.npt_strong' }, (value, context) => {
      return context?.options?.context?.passScore >= SCORE_STRONG
    }),

  new_password_confirmation: Yup.string()
    .required()
    .oneOf([Yup.ref('new_password')], { key: 'field.error.password.no_match' })
    .min(PASSWORD_MIN_LENGTH),
})
